const BASE_URL = "https://dev.distincthealth.com/api";
const TOKEN = "404e725a2b7da700b15e03f2960c57c3e15fb9fe9b3e3d752210d0ffb5349941df5d9148cfe753a8416cd5206ee98c01cf331b4bda0e232a6372cd103689a2d520d6ab4fd0062680c228861e4b9b4cc346d446d3845a6214daa2718b1031fb2f5a27fb6af47a8e2ca5d606d87951a617ec957be9c1c779c7806181a68c68839d";   // same as Flutter

export async function fetchAllAppointments() {
    try {
        const providerUrl =
            `${BASE_URL}/provider-appointments?` +
            `populate[supabase_user]=true&populate[clinic]=true&populate[doctor]=true&` +
            `populate[questionnaire_response][populate][questionnaire]=true`;

        const assistanceUrl =
            `${BASE_URL}/assistance-appointments?` +
            `populate[supabase_user]=true&populate[questionnaire_response][populate][questionnaire]=true`;

        const headers = {
            Authorization: `Bearer ${TOKEN}`,
        };

        // Fetch both collections in parallel
        const [providerRes, assistanceRes] = await Promise.all([
            fetch(providerUrl, { headers }),
            fetch(assistanceUrl, { headers }),
        ]);

        if (!providerRes.ok || !assistanceRes.ok) {
            console.error("❌ Failed to fetch appointments");
            return [];
        }

        const providerJson = await providerRes.json();
        const assistanceJson = await assistanceRes.json();

        // Extract data
        const providerData = providerJson.data || [];
        const assistanceData = assistanceJson.data || [];

        // Add which type they belong to
        const providerList = providerData.map((item) => ({
            ...item,
            type: "Provider",
        }));

        const assistanceList = assistanceData.map((item) => ({
            ...item,
            type: "Assistance",
        }));

        // Merge and sort by createdAt
        const combined = [...providerList, ...assistanceList].sort((a, b) => {
            const aDate = new Date(a.createdAt);
            const bDate = new Date(b.createdAt);
            return bDate - aDate; // newest first
        });


        return combined;
    } catch (err) {
        console.error("❌ Error fetching appointments:", err);
        return [];
    }
}

export async function fetchAppointmentById(id) {
  try {
    const providerUrl =
      `${BASE_URL}/provider-appointments?` +
      `populate[supabase_user]=true&populate[clinic]=true&populate[doctor]=true&` +
      `populate[questionnaire_response][populate][questionnaire]=true&filters[id][$eq]=${id}`;

    const assistanceUrl =
      `${BASE_URL}/assistance-appointments?` +
      `populate[supabase_user]=true&populate[questionnaire_response][populate][questionnaire]=true&filters[id][$eq]=${id}`;

    const headers = {
      Authorization: `Bearer ${TOKEN}`,
    };

    // Fetch both endpoints in parallel
    const [providerRes, assistanceRes] = await Promise.all([
      fetch(providerUrl, { headers }),
      fetch(assistanceUrl, { headers }),
    ]);

    if (!providerRes.ok || !assistanceRes.ok) {
      console.error("❌ Failed to fetch appointment");
      return null;
    }

    const providerJson = await providerRes.json();
    const assistanceJson = await assistanceRes.json();

    const providerData = providerJson.data || [];
    const assistanceData = assistanceJson.data || [];

    if (providerData.length > 0) {
      return { ...providerData[0], type: "Provider" };
    } else if (assistanceData.length > 0) {
      return { ...assistanceData[0], type: "Assistance" };
    } else {
      return null; // not found
    }
  } catch (err) {
    console.error("❌ Error fetching appointment:", err);
    return null;
  }
}

